import React, { useEffect, useState } from "react";
import ImageSlider from "../../views/Graph/ImageSlider";
import "./Objectif.css";
import { carburant2CO2 } from "../../references/glossaire_carburant2CO2";

const Objectif = ({
  medianeLitres,
  cumulLitresTravail,
  carburant,
}: {
  medianeLitres: number;
  cumulLitresTravail: number;
  carburant: string;
}) => {
  const [budgetCO2, setBudgetCO2] = useState(0);

  useEffect(() => {
    setBudgetCO2(
      medianeLitres * carburant2CO2[carburant as keyof typeof carburant2CO2]
    );
  }, [medianeLitres, carburant, cumulLitresTravail, budgetCO2]);

  return (
    <div className="tab-content">
      <div className={"Consommation-main"}>
        <span className={"texte-budget"}>Budget</span>

        <span className={"conso-budget-co2"}>
          {budgetCO2 > 1000
            ? `${Math.round((budgetCO2 / 1000) * 10) / 10} T CO2`
            : `${Math.round(budgetCO2 * 10) / 10} Kg CO2`}
        </span>

        <div className="input-group">
          <ImageSlider
            value={
              cumulLitresTravail *
              carburant2CO2[carburant as keyof typeof carburant2CO2]
            }
            maxValue={budgetCO2}
          />
        </div>
        <span className={"text-consomme"}>Consommé</span>
        <div
          className={
            cumulLitresTravail *
              carburant2CO2[carburant as keyof typeof carburant2CO2] <
            budgetCO2
              ? "poliseMsg conso-consomme-co2"
              : "poliseMsg conso-consomme-co2 depassement"
          }
        >
          {cumulLitresTravail *
            carburant2CO2[carburant as keyof typeof carburant2CO2] >
          1000
            ? `${
                Math.round(
                  ((cumulLitresTravail *
                    carburant2CO2[carburant as keyof typeof carburant2CO2]) /
                    1000) *
                    100
                ) / 100
              } T CO2`
            : `${
                Math.round(
                  cumulLitresTravail *
                    carburant2CO2[carburant as keyof typeof carburant2CO2] *
                    100
                ) / 100
              } Kg CO2`}
        </div>
      </div>
    </div>
  );
};

export default Objectif;
